import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const tenantGroupsRoutes = [
  {
    path: 'groups',
    component: () => import('@/features/superAdmin/tenantGroups/TenantGroups.vue'),
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.GroupsView,
    },
  },
  {
    path: 'groups/:id',
    component: () => import('@/features/superAdmin/tenantGroups/TenantGroupDetail.vue'),
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.GroupsView,
    },
  },
]
